import { Dispatch, SetStateAction } from 'react';

/** Setter for the active cast / pill / lane hover target. */
export type HoverLaneSetter = Dispatch<SetStateAction<string | null>>;

/**
 * Apply pill/popover hover to the shared lane highlight.
 * Clearing is keyed so a delayed close from bar A cannot wipe bar B's highlight.
 */
export function applyLaneHover(
  setHoveredLaneKey: HoverLaneSetter,
  laneKey: string,
  hovered: boolean,
): void {
  if (hovered) {
    setHoveredLaneKey(laneKey);
    return;
  }
  setHoveredLaneKey((prev) => (prev === laneKey ? null : prev));
}
